import BaseModel from './BaseModel';

/** Class representing a cashregister. */
class Cashregister extends BaseModel {}

export default Cashregister;
